import React, { useState, useRef } from 'react';
import { Mic, Square, Save, RotateCcw } from 'lucide-react';

export const AudioRecorder = ({ onTranscriptionComplete }) => {
  const [isRecording, setIsRecording] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);
  const [duration, setDuration] = useState(0);
  const mediaRecorderRef = useRef(null);
  const intervalRef = useRef(null);
  const chunksRef = useRef([]);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ 
        audio: {
          channelCount: 1,
          sampleRate: 44100,
          sampleSize: 16
        } 
      });
      
      mediaRecorderRef.current = new MediaRecorder(stream, {
        mimeType: 'audio/webm;codecs=opus'
      });
      
      chunksRef.current = [];
      
      mediaRecorderRef.current.ondataavailable = (event) => {
        chunksRef.current.push(event.data);
      };
      
      mediaRecorderRef.current.onstop = () => {
        const blob = new Blob(chunksRef.current, { type: 'audio/webm' });
        setAudioBlob(blob);
        stream.getTracks().forEach(track => track.stop());
      };
      
      mediaRecorderRef.current.start();
      setIsRecording(true);
      
      // Timer
      intervalRef.current = setInterval(() => {
        setDuration(prev => prev + 1);
      }, 1000);
      
    } catch (error) {
      console.error('Error accessing microphone:', error);
      alert('Erro ao acessar microfone. Verifique as permissões.');
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && isRecording) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
      clearInterval(intervalRef.current);
    }
  };

  const resetRecording = () => {
    setAudioBlob(null);
    setDuration(0);
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="recorder-container">
      <div className="recorder-controls">
        {!isRecording && !audioBlob && (
          <button onClick={startRecording} className="record-btn">
            <Mic size={24} />
            Iniciar Gravação
          </button>
        )}
        
        {isRecording && (
          <button onClick={stopRecording} className="stop-btn">
            <Square size={24} />
            Parar Gravação
          </button>
        )}
        
        {audioBlob && !isRecording && (
          <div className="audio-actions">
            <button onClick={resetRecording} className="reset-btn">
              <RotateCcw size={20} />
              Nova Gravação
            </button>
            <button 
              onClick={() => onTranscriptionComplete(audioBlob)} 
              className="process-btn"
            >
              <Save size={20} />
              Processar Transcrição
            </button>
          </div>
        )}
      </div>
      
      {isRecording && (
        <div className="recording-indicator">
          <div className="pulse"></div>
          <span>Gravando... {formatDuration(duration)}</span>
        </div>
      )}
      
      {audioBlob && (
        <audio controls src={URL.createObjectURL(audioBlob)} className="audio-player" />
      )}
    </div>
  );
};
